module.exports = __webpack_public_path__ + "static/media/avatar_22.d4de5c6c.svg";